<ng-container *ngIf="(uiService.currentWindowWidth$ | async) >= 300">
  <div class="wide-logo vi-logo !hidden gt-xs:!flex">
    <div class="vi-logo-img">
      <img src="./assets/img/viessmann-white.svg" alt="Viessmann" />
    </div>

    <div class="dot-container">
      <div class="viguide-logo'">
        <img [src]="logoUrl" alt="ViGuide" />
      </div>
    </div>
  </div>
  <div class="vi-logo gt-xs:!hidden">
    <img src="./assets/img/viessmann-v-logo.svg" alt="Viessmann" />
    <div class="dot-container">
      <img [src]="logoUrl" alt="ViGuide" />
    </div>
  </div>
</ng-container>
